document.addEventListener("DOMContentLoaded", () => {
  const videoWrappers = document.querySelectorAll(".customers-quotes__video");
  videoWrappers.forEach((videoWrapper) => {
    const video = videoWrapper.querySelector("video");
    const playBtn = videoWrapper.querySelector(".customers-quotes__video-play-btn");
    const stopBtn = videoWrapper.querySelector(".customers-quotes__video-stop-btn");
    const volumeSlider = videoWrapper.querySelector(".customers-quotes__video-volume");

    playBtn.addEventListener("click", () => {
      video.play();
      playBtn.classList.remove("active");
      stopBtn.classList.add("active");
      volumeSlider.classList.add("show");
    });

    stopBtn.addEventListener("click", () => {
      video.pause();
      stopBtn.classList.remove("active");
      playBtn.classList.add("active");
      volumeSlider.classList.remove("show");
    });

    volumeSlider.addEventListener("input", (e) => {
      video.volume = e.target.value;
    });
  });

  var swiper = new Swiper(".customersQuotesSlider", {
    spaceBetween: 20,
    navigation: {
      nextEl: ".customers-quotes__slider-next",
      prevEl: ".customers-quotes__slider-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });
});
